// extracted by mini-css-extract-plugin
export default {"wrapper":"AllReports_wrapper__ZV9yO","header":"AllReports_header__bGHXP"};